import React from 'react';
import { Helmet } from 'react-helmet-async';

/** Per-post SEO meta tags (title, description, canonical, OpenGraph, Twitter). */
const BlogPostSEO = ({ post }) => {
  const description = post.meta_description || post.excerpt || '';
  const url = `${window.location.origin}/blog/${post.slug}`;

  return (
    <Helmet>
      <title>{post.title} | Bring-A-Nurse Senior Companion</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={post.title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {post.image && <meta property="og:image" content={post.image} />}
      <meta property="article:published_time" content={post.publish_at} />
      <meta property="article:author" content={post.author} />
      <meta property="article:section" content={post.category} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={post.title} />
      <meta name="twitter:description" content={description} />
      {post.image && <meta name="twitter:image" content={post.image} />}
    </Helmet>
  );
};

export default BlogPostSEO;
